module.exports = __webpack_public_path__ + "img/logo_mark_white.da47e550.svg";